/** Mirrors ApplicationSettingTypeEnum (TLP.Sync.Models) */
export enum ApplicationSettingType {
	String = 0,
	Boolean = 1,
	Int = 2,
	Enum = 3,
	StringList = 4,
}

/** One ApplicationSettings row, with its segment names (MVCApplicationSetting) */
export interface ApplicationSetting {
	applicationSettingId: number;
	name: string;
	/** Null when isMasked */
	value: string;
	/** The setting is a secret, so the server left out its value */
	isMasked?: boolean;
	dataType: ApplicationSettingType;
	friendlyName?: string | null;
	settingsGroup?: string | null;
	notes?: string | null;
	createdOn: string;
	updatedOn: string;
	revision: number;
	segmentPriority: number;

	brandId?: number | null;
	channelId?: number | null;
	marketerId?: number | null;
	usStateId?: number | null;
	branchId?: number | null;
	brand?: string | null;
	channel?: string | null;
	marketer?: string | null;
	usState?: string | null;
	branch?: string | null;
}

/** The fields sent when adding or updating a setting */
export type ApplicationSettingToSave = Pick<
	ApplicationSetting,
	| "applicationSettingId"
	| "name"
	| "value"
	| "dataType"
	| "notes"
	| "brandId"
	| "channelId"
	| "marketerId"
	| "usStateId"
	| "branchId"
>;

/** Mirrors AppSettingSaveStatus (TLP.Sync.Business) */
export enum AppSettingSaveStatus {
	Saved = 0,
	/** A row already exists for the same name and segment, and overwrite wasn't requested */
	Exists = 1,
	Invalid = 2,
	NotFound = 3,
}

/** What saving a setting returned */
export interface AppSettingSaveResult {
	status: AppSettingSaveStatus;
	error?: string | null;
	/** The row that blocked the save, when status is Exists */
	existing?: ApplicationSetting | null;
	/** The saved row, when status is Saved */
	setting?: ApplicationSetting | null;
}
